import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { TemplatesService } from 'src/app/business-service/inventory/templates.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-template-form',
  templateUrl: './template-form.component.html',
  styleUrls: ['./template-form.component.scss'],
})
export class TemplateFormComponent  implements OnInit {

  viewOnlyTemplate: boolean = false;

  templateDetailsForm!: FormGroup;

  isTemplateDefault: boolean = false;

  templateId:any;

  templateHtml: SafeHtml = "";
  
  constructor(
    private _modalController: ModalController,
    private _fb: FormBuilder,
    private _templateService: TemplatesService,
    private _sanitizer: DomSanitizer,

    private _reloadService: ComponentReloadService,
    private _validationService: InputValidationsService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
  ) { }

  ngOnInit() {

    this.templateDetailsForm = this._fb.group({
      templateId: [''],
      id: [''],
      organizationId: [''],
      name: ["", [Validators.required]],
      title: ["", [Validators.required]],
      primaryColor: ["", Validators.required],
      secondaryColor: ["", Validators.required],
      enquiryNumber1: [{countryCode: '+91', phone: '' }, Validators.required],
      enquiryNumber2: [{countryCode: '+91', phone: '' }, Validators.required],
      createDate: [''],
      createdBy: [''],
      baseTemplateId: [''],
      isVisibleInQuote: [''],
      defaultTemplate: ['']
    });

    this.templateDetailsForm.valueChanges.subscribe(() =>{
      this.templateDetailsForm.markAsDirty();
      this.templateDetailsForm.markAsTouched();
    });

    if(this.templateId){
      this._templateService.getInventoryTemplate(this.templateId).subscribe((data)=>{        
        this.patchFormData(data);
        this.templateDetailsForm.markAsPristine();
      })
    }
  }

  closeModal(){
    this._modalController.dismiss();
  }

  enableEdit(){
    this.viewOnlyTemplate = false;
  }

  patchFormData(formData:any){
    this.templateDetailsForm.patchValue(formData);

    this.templateDetailsForm.patchValue({
      enquiryNumber1: {countryCode: '+91', phone: formData.enquiryNumber[0] || "" },
      enquiryNumber2: {countryCode: '+91', phone: formData.enquiryNumber[1] || "" },
    });

    this.templateHtml = this._sanitizer.bypassSecurityTrustHtml(formData.content);

    this.isTemplateDefault = formData.defaultTemplate;

    this.templateDetailsForm.markAsPristine();
  }

  setTemplateAsDefault(){
    this.templateDetailsForm.get('defaultTemplate')?.setValue(true);
    this.onSubmit();
  }

  onSubmit(){
    if(this.templateDetailsForm.valid){
      if(this.templateId){

        let enquiryNumber1 = this.templateDetailsForm.get('enquiryNumber1')?.value;
        let enquiryNumber2 = this.templateDetailsForm.get('enquiryNumber2')?.value;
          
        // Create a new FormData object
        const formData = new FormData();
      
        // Append non-file fields
        formData.append('templateId', this.templateDetailsForm.get('templateId')?.value);
        formData.append('name', this.templateDetailsForm.get('name')?.value);
        formData.append('title', this.templateDetailsForm.get('title')?.value);
        formData.append('primaryColor', this.templateDetailsForm.get('primaryColor')?.value);
        formData.append('secondaryColor', this.templateDetailsForm.get('secondaryColor')?.value);
        formData.append('enquiryNumber1', enquiryNumber1.phone);
        formData.append('enquiryNumber2', enquiryNumber2.phone);
        formData.append('id', this.templateDetailsForm.get('id')?.value);
        formData.append('organizationId', this.templateDetailsForm.get('organizationId')?.value)
        formData.append('createDate', this.templateDetailsForm.get('createDate')?.value)
        formData.append('createdBy', this.templateDetailsForm.get('createdBy')?.value)
        formData.append('baseTemplateId', this.templateDetailsForm.get('baseTemplateId')?.value)
        formData.append('isVisibleInQuote', this.templateDetailsForm.get('isVisibleInQuote')?.value)
        formData.append('defaultTemplate', this.templateDetailsForm.get('defaultTemplate')?.value)

        this._templateService.updateInventoryTemplate(this.templateId, formData).subscribe((data)=>{
          this._reloadService.triggerInventoryTemplateReload();
          this.ngOnInit();
        })
      }
    }else{
      this.templateDetailsForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
    }
    
  }


  async serilizeFormData(formData:any){
    var serializedData = formData;
    formData.enquiryNumber = [formData.enquiryNumber1.phone, formData.enquiryNumber2.phone];
    delete serializedData.enquiryNumber1;
    delete serializedData.enquiryNumber2;
    return serializedData;
  }

  formDataModified(){
    return (this.templateDetailsForm.dirty || this.templateDetailsForm.invalid) && this.templateDetailsForm.touched;
  }
}
